import { render, staticRenderFns } from "./scan-type-step.vue?vue&type=template&id=084eaa96"
import script from "./scan-type-step.vue?vue&type=script&lang=js"
export * from "./scan-type-step.vue?vue&type=script&lang=js"
import style0 from "./scan-type-step.vue?vue&type=style&index=0&id=084eaa96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports